<template>
  <Wrapper :type="type" @delete="$emit('delete')">
    <div slot="preview">
      <v-img
        :src="data.src"
        :height="200"
        contain
        @error="loadingError = true"
      />
      <v-alert :value="loadingError" type="error">
        This image cannot be loaded here.
      </v-alert>
    </div>
    <v-layout slot="edition" wrap row>
      <v-flex xs6>
        <v-text-field
          :value="data.src"
          label="Source"
          outline
          @input="setValue"
        ></v-text-field>
      </v-flex>
      <v-flex xs6>
        <Storage v-model="data.src" type="contentPages" />
      </v-flex>
    </v-layout>
  </Wrapper>
</template>

<script>
import Wrapper from "../../components/widgets/Wrapper";
import Storage from "../../components/Storage";

export default {
  name: "WidgetImage",
  components: {
    Wrapper,
    Storage
  },
  model: {
    prop: "data"
  },
  props: {
    type: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loadingError: false
    };
  },
  methods: {
    setValue(src) {
      this.loadingError = false;
      this.$emit("input", {
        src
      });
    }
  }
};
</script>
